import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import AuditLogDownloadLinkInfoDto = Cloud.RavenDB.Core.Dto.AuditLogs.AuditLogDownloadLinkInfoDto;

export default class ProductAuditLogsService extends AbstractService {
    getAuditLogs = async (props: {
        domain: string;
        productId: string;
        nodeTag: string;
        date: string;
    }): Promise<AuditLogDownloadLinkInfoDto[]> => {
        const { domain, productId, nodeTag, date } = props;
        const auditLogs = await this.post<AuditLogDownloadLinkInfoDto[]>(
            ApiRoutes.auditLog.listAuditLogs({ domain, productId, nodeTag, date })
        );
        return auditLogs.data;
    };
}
